<template>
  <div>
    <arrorImg bg="white"></arrorImg>
    <navBar title="订阅管理" :pagetype="pageType" color="#ffffff"></navBar>
    <div class="content-box">
      <p>开启自动订阅后，进入书籍付费章节将自动订阅</p>
      <div class="content" v-if="!isEmpaty">
        <ul
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <li
            class="consume-item"
            v-for="(item, index) in customList"
            :key="index"
          >
            <div class="item-list">
              <div>
                <img
                  :src="item.bookLogoUrl"
                  alt=""
                />
                <div>
                  <p>{{item.bookName}}</p>
                  <p>读至 第{{item.chapterOrders}}章 {{item.chapterName}}</p>
                </div>
              </div>
              <img @click="changeStatus(item)" :src="item.status==0?'../../../static/switch-open.png':'../../../static/switch-close.png'" alt="" />
            </div>
          </li>
        </ul>
        <div class="load-more">
          <span>{{ !isLoading ? "加载中" : loadText }}</span>
        </div>
      </div>
      <div class="no-log" v-else>
        <img src="../../../static/no-log.png" alt="" />
        <span>暂无内容~</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox, InfiniteScroll } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name: "bookBuyManage",
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      loading: false,
      isEmpaty: false,
      pageNo: 1,
      customList: [],
      loadText: "加载中...",
      pageCount: 1,
      isEntranceData: "",
      isLoading: false,
      pageType:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.getAccountAutoSubList();
    } else {
      this.getAccountAutoSubList();
    }
    this.$commonApi.share();
  },
  methods: {
    loadMore() {
      this.loading = true;
      if (this.pageNo < this.pageCount) {
        this.pageNo += 1;
        this.getAccountAutoSubList();
      } else {
        this.loadText = "没有更多了";
        this.loading = false;
      }
    },
changeStatus(item){
  if(item.status==0){
    item.status=1;
  }else{
       item.status=0;
  }
  var params={
    bookId:item.bookId,
    isauto:item.status
  }
    this.$api.autobuy(params).then((res) => {
       if (res.status == 1) {
       }else{
         Toast({
            message: res.message,
          });
       }
    });
},
    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCity") {
        prevPage = "书城";
      } else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      }else if (this.pageType === "bookMine") {
        prevPage = "我的";
      }
      var params = {
        pageName: "订阅管理",
        pageRemark: "上级页面:"+prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getAccountAutoSubList() {
      var params = {
        pageNo: this.pageNo,
        pageSize: 10,
      };
      this.isLoading = false;
      this.$api.getAccountAutoSubList(params).then((res) => {
        if (res.status == 1) {
          this.pageCount = res.pages;
          if (this.pageNo == 1) {
            this.customList = res.data;
            if (this.pageCount <= 1) {
              this.loadText = "没有更多了";
            } else {
              this.loadText = "加载中...";
            }
          } else {
            this.customList = this.customList.concat(res.data);
          }
          if (this.customList.length == 0) {
            this.isEmpaty = true;
          } else {
            this.isEmpaty = false;
          }
          this.isLoading = true;
          this.insertPageAccessData();
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  padding: 0px 16px;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
  border-top: 1px solid #f3f3f3;
}

.consume-item {
  width: 100%;
  padding: 16px 0px;
  border-bottom: 1px solid #f3f3f3;
}
.item-list{
  display: flex;
  justify-content: space-between;
}
.item-list>img{
  width: 30px;
  height: 16px;
  margin-top: 27px;
}
.item-list>div img{
  width: 54px;
  height: 70px;
  border-radius: 10px;
  margin-right: 7px;;
}
.item-list>div{
  display: flex;
}
.item-list>div>div{
  width: 192px;
}
.item-list>div p:nth-of-type(1){
  font-size: 15px;
color: #333333;
margin-bottom:9px;
margin-top: 12px;
overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.item-list>div p:nth-of-type(2){
 font-size: 12px;
color: #888888;

overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.content-box > p {
  font-size: 12px;
  color: #de3b34;
  background: #f9d8d8;
  height: 24px;
  line-height: 24px;
  text-align: center;
}

.content-box {
  padding-top: calc(44px + env(safe-area-inset-top));
}
.consum-left {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.consum-left > span {
  display: block;
  font-size: 14px;
  color: #3d3d3d;
}
.consum-left > span:nth-child(1) {
  margin-bottom: 4px;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
  height: 20px;
}
.consum-right {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}
.consum-right > span:nth-child(1) {
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 60%;
}
.consum-right > span:nth-child(2) {
  color: #aaaaaa;
  text-align: right;
}
.load-more {
  text-align: center;
  font-size: 12px;
  color: #aaaaaa;
  padding: 16px 0px;
}

.no-log {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.no-log img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
}

.no-log span {
  display: block;
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookBuyManage/index.vue